<uilab-nav-rail
    #navrail
    id="navRail"
    [ngClass]="busy ? 'noshow' : 'show'"
    [class.mobileShow]="isCollapsed"
    class="uilab-nav-rail"
    [items]="navRail"
    [activeRoute]="activeRoute"
    [subMenuType]="'sidesheet'"
    (menuItemSelected)="navTo($event)"
    (collapsedEmitter)="collapsed($event)"
    [collapsed]="isCollapsed"
    [attr.aria-expanded]="isCollapsed"
></uilab-nav-rail>
@if (busy) {
    <app-navrail-blockframe class="hideMobile"></app-navrail-blockframe>
}
